import React, { useState, useRef } from "react";
import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { addDofollowToAnchors } from "../../utils/modifyHtmlLinks";
import Link from "next/link";

const FaqSection = ({ faqs }) => {
  const router = useRouter();
  const { t } = useTranslation("common");
  const [openIndex, setOpenIndex] = useState(null);
  const contentRefs = useRef([]);

  const toggleIndex = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section className="w-full box-border text-text-primary px-[24px] md:px-[60px] lg:px-[80px] xl:px-[80px] pb-[40px] md:pb-[40px] lg:pb-[60px] xl:pb-[60px] max-w-[1600px] mx-auto">
      <div className="mx-auto flex flex-col gap-6 md:gap-10">
        {/* Header */}
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-6">
          <h2 className=" font-medium text-[28px] sm:text-[32px] lg:text-[40px] leading-[120%] m-0">
            {t("faqs.title")}
          </h2>
          <Link
            href="/faqs"
            className="no-underline rounded-[50px] bg-crimson text-white text-[16px] font-medium py-3 px-6 cursor-pointer hover:bg-[#e72c46] transition duration-300 ease-in-out"
          >
            {t("faqs.btnTxt")}
          </Link>
        </div>

        <div className="flex flex-col gap-4">
          {Array.isArray(faqs) &&
            faqs.map((item, index) => {
              const isOpen = openIndex === index;

              return (
                <div
                  key={index}
                  className="w-full border-gray-500 border-solid border-b-[1px] box-border"
                >
                  <button
                    onClick={() => toggleIndex(index)}
                    className="w-full p-0 pb-4 flex justify-between items-center text-start text-black bg-transparent cursor-pointer"
                  >
                    <h3 className=" font-medium text-[20px] leading-[140%] m-0">
                      {item?.question}
                    </h3>
                    {isOpen ? (
                      <AiOutlineMinus className="w-6 h-6 text-black" />
                    ) : (
                      <AiOutlinePlus className="w-6 h-6 text-black" />
                    )}
                  </button>

                  <div
                    ref={(el) => (contentRefs.current[index] = el)}
                    className="transition-all duration-300 ease-in-out overflow-hidden"
                    style={{
                      maxHeight: isOpen
                        ? `${contentRefs.current[index]?.scrollHeight}px`
                        : "0px",
                    }}
                  >
                    <div className="pb-4">
                      <div
                        className=" font-normal text-[16px] leading-[150%] text-black p-0 m-0 rich-text"
                        dangerouslySetInnerHTML={{
                          __html: addDofollowToAnchors(item?.answer) || "",
                        }}
                      />
                      {/* {item?.answer}
                    </p> */}
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
